<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout class="elevation-2">
      <v-flex>
        <v-card
          height="100%"
          style=""
          flat
        >
          <map-component
            :map-id="mapId"
            :fullscreen-button="true"
            :draw-enabled="true"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MapComponent from "./map/Map";
import MapContainerMixins from "@/mixins/mapContainerMixins";
import nanoid from "nanoid";

export default {
  data() {
    return {
      mapId: null,
      mapHeight: "0px"
    };
  },

  computed: {},

  methods: {},

  beforeMount() {
    this.mapId = nanoid();
  },

  mounted() {
    this.$nextTick(function() {
      this.generatePartnerTypesDataSources(true);
      this.generateEventsDataSources();
      this.generateActiveEventsDataSources();
      this.generateInreachLastPositionsDataSources();
      this.generateOtherDataSources();
    });
  },

  components: {
    MapComponent
  },

  mixins: [MapContainerMixins]

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MainMap.vue